import styled from '@emotion/styled';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { WhiteButton } from '../ui/Button';
import { useProject } from './context/useProject';
import LoadingButton from '../ui/LoadingButton';

const StyledDialogContent = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

interface Props {
  open: boolean;
  onClose: () => void;
}

const ValidateProjectModal = ({ open, onClose }: Props) => {
  const [isValidated, setIsValidated] = useState(false);
  const { projectId } = useParams();
  const {
    project,
    validateProject,
    loadingValidateProject: loading,
  } = useProject(projectId);
  const { t } = useTranslation(['project']);

  if (!project) return null;

  const handleValidate = async () => {
    if (!isValidated) {
      await validateProject();
      setIsValidated(true);
    } else {
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('project:validation-modal.title')}</DialogTitle>
      <StyledDialogContent dividers>
        <DialogContentText>
          {t('project:validation-modal.explanation-text')}
        </DialogContentText>
      </StyledDialogContent>
      <DialogActions>
        <WhiteButton onClick={onClose}>{t('common:cancel')}</WhiteButton>
        <LoadingButton onClick={handleValidate} loading={loading}>
          {t('common:validate')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ValidateProjectModal;
